module.exports = __webpack_public_path__ + "img/saving-ar.e624a0a3.png";